import React from "react";
import { MENU_ITEM_ICON_DISABLED_COLOR } from "components/sideBar/sideBar";

interface IconProps {
  readonly isDisabled?: boolean;
}

export const MyHealthLearningCenterIcon: React.FC<IconProps> = ({
  isDisabled
}) => {
  return (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 40 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <desc>Created with Sketch.</desc>
      <defs>
        <path
          d="M12,0 L12,0 C18.627417,-1.21743675e-15 24,5.372583 24,12 L24,12 C24,18.627417 18.627417,24 12,24 L12,24 C5.372583,24 8.11624501e-16,18.627417 0,12 L0,12 C-8.11624501e-16,5.372583 5.372583,1.21743675e-15 12,0 Z"
          id="path-1"
        ></path>
        <filter
          x="-54.2%"
          y="-45.8%"
          width="208.3%"
          height="208.3%"
          filterUnits="objectBoundingBox"
          id="filter-2"
        >
          <feOffset
            dx="0"
            dy="2"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="4"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="CareGEM-Patient-MyHealthStatus-MyCurrentStatus-V1.1"
          transform="translate(-13.000000, -131.000000)"
        >
          <g id="Care-Plan-menu" transform="translate(14.000000, 131.000000)">
            <g
              id="learning-center-icon"
              transform="translate(7.000000, 6.000000)"
            >
              <g id="Rectangle-Copy-212">
                <use
                  fill="black"
                  fillOpacity="1"
                  filter="url(#filter-2)"
                  xlinkHref="#path-1"
                ></use>
                <use
                  fill={isDisabled ? MENU_ITEM_ICON_DISABLED_COLOR : "#7CBA5B"}
                  fillRule="evenodd"
                  xlinkHref="#path-1"
                ></use>
              </g>
              <path
                d="M14.2367788,8.24423089 C14.3349364,8.21618588 14.4225757,8.23196096 14.4996995,8.29155661 C14.5768233,8.35115227 14.6153846,8.43002768 14.6153846,8.52818522 L14.6153846,12.6192309 C14.6153846,12.7033659 14.58734,12.7813649 14.53125,12.8532303 C14.47516,12.9250956 14.4068013,12.9715445 14.3261719,12.9925782 L12.101863,13.5972958 C12.0668067,13.6078127 12.0308746,13.6148238 11.9940655,13.6183295 C11.9572564,13.6218351 11.9248299,13.6235879 11.8967849,13.6235879 C11.858223,13.6235879 11.820538,13.6209587 11.783729,13.6157002 C11.7469199,13.6104418 11.7144933,13.6043071 11.6864483,13.5972958 L9.51998197,12.9978367 C9.43935256,12.9732973 9.37099387,12.9250956 9.31490385,12.8532303 C9.25881382,12.7813649 9.23076923,12.7033659 9.23076923,12.6192309 L9.23076923,8.52818522 C9.23076923,8.43002768 9.26933054,8.35115227 9.34645433,8.29155661 C9.42357811,8.23196096 9.51121746,8.21618588 9.609375,8.24423089 L11.7758413,8.84369003 C11.8038864,8.85070128 11.8433241,8.85420686 11.8941556,8.85420686 C11.9449872,8.85420686 11.9844249,8.85070128 12.01247,8.84369003 L14.2367788,8.24423089 Z M11.7548077,13.2660157 L11.7548077,9.18022849 C11.7442908,9.18022849 11.7328977,9.1784757 11.720628,9.17497008 C11.7083583,9.17146445 11.6969652,9.16971166 11.6864483,9.16971166 L9.56730769,8.58076936 L9.56730769,12.6192309 C9.56730769,12.6297478 9.57168966,12.6402645 9.58045373,12.6507814 C9.58921779,12.6612983 9.59710533,12.6683094 9.60411659,12.671815 L11.7548077,13.2660157 Z M14.2788462,12.6192309 L14.2788462,8.58076936 L12.101863,9.16971166 L12.0913462,9.16971166 L12.0913462,13.2502405 L14.2367788,12.671815 C14.2437901,12.6683094 14.252554,12.6612983 14.2630709,12.6507814 C14.2735878,12.6402645 14.2788462,12.6297478 14.2788462,12.6192309 Z"
                id="book-open---simple-line-icons"
                stroke="#FFFFFF"
                strokeWidth="0.7"
                fill="#FFFFFF"
              ></path>
              <path
                d="M11.9847756,5 C12.910261,5 13.7380439,5.14127463 14.468149,5.42382812 C15.1982542,5.70638162 15.8126644,6.09146892 16.3113982,6.57910156 C16.810132,7.06673421 17.1906037,7.63411135 17.4528245,8.28125 C17.7150454,8.92838865 17.8461538,9.61197557 17.8461538,10.3320312 C17.8461538,11.0612016 17.6841963,11.8063113 17.3602764,12.5673828 C17.0363566,13.3284543 16.6276066,14.0758427 16.1340144,14.8095703 C15.6404222,15.5432979 15.1057053,16.238278 14.5298478,16.8945312 C13.9539902,17.5507845 13.4141318,18.134112 12.9102564,18.6445312 C12.9102564,18.6536459 12.8331338,18.7151687 12.6788862,18.8291016 C12.5246387,18.9430344 12.3446859,19 12.1390224,19 L12.0927484,19 C11.8768018,19 11.6942783,18.9430344 11.5451723,18.8291016 C11.3960663,18.7151687 11.3215144,18.6536459 11.3215144,18.6445312 C10.7867895,18.0976535 10.2083698,17.5006543 9.58623798,16.8535156 C8.96410613,16.206377 8.38825719,15.5250687 7.85867388,14.8095703 C7.32909057,14.0940719 6.88692084,13.3580767 6.53215144,12.6015625 C6.17738204,11.8450483 6,11.0885454 6,10.3320312 C6,9.61197557 6.15938676,8.92838865 6.47816506,8.28125 C6.79694337,7.63411135 7.22883007,7.06673421 7.77383814,6.57910156 C8.31884621,6.09146892 8.9538225,5.70638162 9.67878606,5.42382812 C10.4037496,5.14127463 11.1724051,5 11.9847756,5 Z M12.1653846,17.8701332 C12.9326961,17.1024457 13.6040837,16.3700651 14.1795673,15.6729695 C14.755051,14.9758739 15.2346135,14.3162902 15.6182692,13.6941985 C16.001925,13.0721069 16.2896625,12.48532 16.4814904,11.9338204 C16.6733183,11.3823207 16.7692308,10.8683307 16.7692308,10.391835 C16.7692308,9.8535713 16.6758423,9.32634551 16.4890625,8.81014181 C16.3022827,8.29393812 16.0120212,7.8328913 15.6182692,7.42698754 C15.2245173,7.02108377 14.7272867,6.69460086 14.1265625,6.44752901 C13.5258383,6.20045715 12.8115426,6.07692308 11.9836538,6.07692308 C11.3173044,6.07692308 10.6863011,6.19163329 10.090625,6.42105716 C9.49494894,6.65048102 8.97500222,6.96152217 8.53076923,7.35418994 C8.08653624,7.74685771 7.73317439,8.20569856 7.47067308,8.73072626 C7.20817176,9.25575395 7.07692308,9.80945132 7.07692308,10.391835 C7.07692308,11.0183386 7.22836387,11.6536567 7.53125,12.2978083 C7.83413613,12.94196 8.21778614,13.5750721 8.68221154,14.1971637 C9.14663694,14.8192554 9.65648761,15.419278 10.2117788,15.9972497 C10.7670701,16.5752213 11.2920648,17.1156829 11.7867788,17.6186506 L12.0442308,17.8701332 L12.1048077,17.9230769 C12.1149039,17.9142529 12.127524,17.9054291 12.1426683,17.8966051 C12.1578126,17.8877811 12.1653846,17.8789572 12.1653846,17.8701332 Z"
                id="location-pin---simple-line-icons"
                stroke="#FFFFFF"
                strokeWidth="0.2"
                fill="#FFFFFF"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
